import { useQuery } from '@tanstack/vue-query';
import { unwrapResponse } from '~/utils/unwrapResponse';

export type UseProfileQueryOptions = {
	enabled?: MaybeRef<boolean>;
	ignoreSentry?: MaybeRef<boolean>;
};

export const fetchProfileFn = async () => {
	const { $api } = useNuxtApp();
	return $api.GET('/me').then(unwrapResponse);
};

export const useProfileQuery = (options?: UseProfileQueryOptions) => {
	const query = useQuery({
		queryKey: ['profile'],
		queryFn: fetchProfileFn,
		enabled: options?.enabled,
		retry: false,
		meta: computed(() => ({
			ignoreSentry: unref(options?.ignoreSentry),
		})),
	});

	return query;
};
